import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInput } from 'components/common/ns-input/NsInput';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsTextInputProps = {
  id?: string;
  label?: string;
  helper?: string;
  name?: string;
  type?: 'text' | 'email' | 'tel' | 'number' | 'radio' | 'checkbox' | 'search';
  testId?: string;
  onChange?: (event: NsInputterEvent) => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
  validation?: string[];
  className?: string;
  mask?: string;
  separator?: string;
  ignoreseparator?: boolean;
  heading?: string;
  pattern?: string;
  tipDetail?: React.ReactNode;
  placeholder?: string;
};

export const NsTextInput = ({
  id,
  label,
  helper,
  type,
  name,
  validation,
  value,
  testId,
  onChange,
  inputAttributes,
  className,
  mask,
  separator,
  ignoreseparator,
  heading,
  pattern,
  tipDetail,
  placeholder
}: NsTextInputProps) => {
  return (
    <NsInputter
      validation={validation}
      value={value}
      name={name}
      helper={helper}
      onChange={onChange}
      className={className}
      mask={mask}
      separator={separator}
      ignoreseparator={ignoreseparator}
      heading={heading}
      tipDetail={tipDetail}
    >
      <NsInput
        label={label}
        name={name}
        id={id}
        type={type}
        pattern={pattern}
        inputAttributes={inputAttributes}
        testId={testId}
        placeholder={placeholder}
      />
    </NsInputter>
  );
};
